import * as React from 'react'
import { connect } from "react-redux";
import { ActionType, cashierType, PAY_STATUS, reducerStoreType, transQrType } from "../../reducers/types";
import { Dispatch } from "redux";
import './TransQrModal.scss';
import AlipayLogo from '../../images/alipay_logo.png'
import WechatLogo from '../../images/wechat_logo.svg'
import { injectIntl, IntlShape } from "react-intl";

var QRCode = require('qrcode.react')

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  transQr: transQrType,
  cashier: cashierType,
  currency: string,
  merchantName: string,
  fee: string,
  intl: IntlShape
}

class TransQrModal extends React.Component<IProps, {}> {
  public render() {
    let { transQr, intl } = this.props
    return (<div className="transQrModal">
      {this.props.cashier.payChannel === 'Alipay' ?
        <img src={AlipayLogo} alt="Alipay" className="walletLogo" /> : null}
      {this.props.cashier.payChannel === 'Wechat' ?
        <img src={WechatLogo} alt="Wechat" className="walletLogo" /> : null}

      <div className="qrArea">
        <QRCode value={transQr.qrcode} size={165} />
      </div>
      <div className="info">
        <div className="merchantName">{this.props.merchantName}</div>
        <span className="invalidTime">{intl.formatMessage({ id: 'expireTime' })}：{transQr.invalidTime}</span>
      </div>
      <div className="divide"></div>
      <div className="tradeInfo">
        <div
          className="amt">{this.props.cashier.checkcurr} {Number(this.props.cashier.amt) + Number(this.props.fee)}</div>
        {this.props.cashier.remark ?
          <div className="remark">{this.props.cashier.remark}</div> : null}
      </div>
      <div className="payStatus">
        {transQr.status === PAY_STATUS.UNPAID ?
          <div className="unpaid">
            <span className="icon icon-wait"></span>
            <p>{intl.formatMessage({ id: 'unpaid' })}</p>
          </div> : null}
        {transQr.status === PAY_STATUS.PAY_SUCCESS ?
          <div className="success">
            <span className="icon icon-success"></span>
            <p className="blue">{intl.formatMessage({ id: 'paySucc' })}</p>
          </div> : null}
        {transQr.status === PAY_STATUS.PAY_FAIL ?
          <div className="unpaid">
            <span className="icon icon-wait"></span>
            <p>{intl.formatMessage({ id: 'transFailed' })}</p>
          </div> : null}
      </div>
    </div>);
  }
}

export default injectIntl(connect((state: reducerStoreType) => {
  return {
    transQr: state.dashboard.transQr,
    cashier: state.dashboard.cashier,
    merchantName: state.merchant.merchantInfo.name,
    currency: state.merchant.merchantInfo.currency
  }
})(TransQrModal))
